import React, { useState, useEffect } from 'react';
import { CATEGORIES, BUSINESSES, Business } from '../data';
import { Reveal } from './Reveal';

// Duplicate the lists so the drifting bands loop seamlessly.
const BAND = [...CATEGORIES, ...CATEGORIES];
const PARTNER_BAND = [...BUSINESSES, ...BUSINESSES, ...BUSINESSES, ...BUSINESSES];
function PartnerLogo({
  business
}: {
  business: Business;
}) {
  const [isHovered, setIsHovered] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isHovered && business.products && business.products.length > 0) {
      interval = setInterval(() => {
        setCurrentImageIndex(prev => (prev + 1) % business.products.length);
      }, 600); // Shift image every 600ms
    } else {
      setCurrentImageIndex(0);
    }
    return () => clearInterval(interval);
  }, [isHovered, business.products]);
  return <a href={`/partner/${business.slug}`} className="group relative flex h-48 w-72 cursor-pointer items-center justify-center overflow-hidden rounded-sm border border-brun/10 bg-beige transition-colors hover:border-brun/30" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-58" data-mp="1t1gsc88skcmo">
      {/* Typographic Logo (Default State) */}
      <div className={`absolute inset-0 flex flex-col items-center justify-center p-6 text-center transition-opacity duration-300 ${isHovered ? 'opacity-0' : 'opacity-100'}`} data-id="element-59" data-mp="31digqowert9y">
        <h3 className="font-display text-2xl text-brun" data-id="element-60" data-mp="2rfunk3egattw">{business.name}</h3>
        {business.place && <p className="mt-2 text-[10px] uppercase tracking-wide2 text-brun-soft" data-id="element-61" data-mp="2dgl5szaljrnt">{business.place}</p>}
      </div>

      {/* Hover Carousel */}
      <div className={`absolute inset-0 transition-opacity duration-300 ${isHovered ? 'opacity-100' : 'opacity-0'}`} data-id="element-62" data-mp="2ig7in7mij5w3">
        {business.products && business.products.length > 0 && <img src={business.products[currentImageIndex].image} alt={`${business.name} product`} className="h-full w-full object-cover" data-id="element-63" data-mp="gob6bvsits09" />}
        <div className="absolute inset-0 bg-brun/40" data-id="element-64" data-mp="a7jgee0eurby" />
        <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center" data-id="element-65" data-mp="aa5oqfv4lav8">
           <h3 className="font-display text-xl text-warm drop-shadow-md" data-id="element-66" data-mp="5ajaq47h3qld">{business.name}</h3>
           <p className="mt-2 rounded-full border border-warm/50 px-4 py-1.5 text-[10px] uppercase tracking-wide2 text-warm backdrop-blur-sm" data-id="element-67" data-mp="bpu42ww3jgz">Se utbud</p>
        </div>
      </div>
    </a>;
}
export function Categories() {
  return <section id="utbud" className="w-full bg-warm py-28 md:py-40" data-id="element-68" data-mp="o72c27c1ca7d">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-69" data-mp="o57qqrwuqg2r">
        <div className="grid items-end gap-10 md:grid-cols-2" data-id="element-70" data-mp="j7prjt8mzf7y">
          <Reveal data-id="element-71" data-mp="1gnlic9rlh5te">
            <p className="mb-6 text-[12px] uppercase tracking-wide3 text-terrakotta" data-id="element-72" data-mp="1go4x5hly7e37">
              Våra partners
            </p>
            <h2 className="font-display text-4xl font-light leading-tight text-brun md:text-5xl" data-id="element-73" data-mp="1bvlisiffsexc">
              Handplockade verksamheter.
            </h2>
          </Reveal>
          <Reveal delay={0.15} data-id="element-74" data-mp="1o8fl3paoiheq">
            <p className="max-w-md text-lg leading-relaxed text-brun-soft md:justify-self-end" data-id="element-75" data-mp="1o7o018epk22p">
              Från bagerier och specialkaffe till privatkockar och lokala producenter – ett noggrant
              utvalt urval av Smålands bästa.
            </p>
          </Reveal>
        </div>
      </div>

      {/* Drifting categories band */}
      <div className="marquee-mask mt-16 overflow-hidden md:mt-20" data-id="element-76" data-mp="276080qtvv5wp">
        <div className="flex w-max animate-drift gap-6 pr-6" data-id="element-77" data-mp="2745qznlqfxxw">
          {BAND.map((c, i) => <span key={`${c}-${i}`} className="whitespace-nowrap font-display text-3xl font-light text-brun/70 md:text-4xl" data-id="element-78" data-mp="2bz1r7b14hrm3" data-mpi={i}>
              {c}
              <span className="ml-6 text-terrakotta" data-id="element-79" data-mp="2lwzgm1upxuga">·</span>
            </span>)}
        </div>
      </div>

      {/* Interactive Partner Marquee */}
      <div className="marquee-mask mt-12 overflow-hidden md:mt-16" data-id="element-80" data-mp="3nkupk0rqmp8i">
        <div className="flex w-max animate-drift-slow gap-6 pr-6 hover:[animation-play-state:paused]" data-id="element-81" data-mp="3imjfpq1g0eqa">
          {PARTNER_BAND.map((b, i) => <PartnerLogo key={`${b.name}-${i}`} business={b} data-id="element-82" data-mp="150a4c0pcgem" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}